import React from "react";
import Lottie from "react-lottie";
import "./Data_Loader_lottie.css";
import animationData from "./Data_Loader_lottie.json";

const Data_Loader_lottie = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="Data_Loader_lottie_icon">
        <Lottie
          options={defaultOptions}
        />
      </div>
    </section>
  );
};

export default Data_Loader_lottie;